import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { WorksheetService } from '@pbx/services/WorksheetService';

class WorksheetModalService extends ModalService {
  constructor() {
    super(WorksheetService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.worksheet.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }
}

const instance = new WorksheetModalService();
export { instance as WorksheetModalService };
